import React, { useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../config/config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "./AuthContext";
import backgroundImage from "../assets/images/admin-bg.jpg";
import ReCAPTCHAComponent from "../common/googleCaptcha";

function Login() {
  const { setLoginStatus } = useAuth();
  const { API_BASE_URL } = config;
  //const API_BASE_URL = "192.168.1.51:5152"
  const navigate = useNavigate();
  const location = useLocation();
  //   const from = location.state?.from || "";
  const isPOSLogin = location.pathname.startsWith("/pos");
  // console.log("PATH:", location.pathname);
  // console.log("isPOSLogin:", isPOSLogin);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isCaptchaValid, setisCaptchaValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleRecaptcha = (value) => {
    setisCaptchaValid(!!value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // SignIn handler
  // const handleSignIn = async (e) => {
  //     e.preventDefault();

  //     try {
  //         const response = await fetch(`${API_BASE_URL}/auth/SignIn`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify(formData),
  //         });

  //         if (response.ok) {
  //             setLoginStatus(true);
  //             localStorage.setItem('isLoggedIn', JSON.stringify(true));
  //             navigate('/pos');
  //         } else {
  //             toast.error('Invalid email or password');
  //         }
  //     } catch (error) {
  //         console.error('Error signing in:', error);
  //         toast.error('An error occurred while signing in');
  //     }
  // };
  const handleSignIn = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/auth/SignIn`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const resData = await response.json();

      if (response.ok) {
        // ✅ store login info
        localStorage.setItem(
          "auth",
          JSON.stringify({
            token: resData.token,
            userId: resData.userId,
            email: resData.email,
            role: resData.role,
            firstname: resData.firstname,
            lastname: resData.lastname,
            mobile: resData.mobile,
            gender: resData.gender,
          }),
        );
        localStorage.setItem("isLoggedIn", "true");

        setLoginStatus(true);

        const role = resData.role;
        console.log("Before redirecting Role", role, isPOSLogin);
        if (isPOSLogin) {
          if (role === "Admin") {
            navigate("/pos/orders", { replace: true });
          } else {
            navigate("/pos/sell", { replace: true });
          }
        } else if (!isPOSLogin) {
          navigate("/profile-dashboard", { replace: true });
        } else {
          console.log("Why is it redirecting at /login page");
          navigate("/login", { replace: true });
        }
      } else {
        toast.error(resData.message || "Invalid email or password");
      }
    } catch (error) {
      toast.error("An error occurred while signing in");
    }
  };

  //   return (
  //     <div>
  //       <section className="relative lg:mt-0 md:mt-0 xl:mt-0 mt-2">
  //         <img
  //           src={backgroundImage}
  //           alt="Background"
  //           className="absolute inset-0 w-full h-full object-cover brightness-75"
  //         />

  //         <div className="relative flex flex-col items-center justify-center px-6 py-3 mx-auto md:h-screen lg:py-0">
  //           <div className="w-full bg-white rounded-lg shadow md:mt-0 mt-6 sm:max-w-md xl:p-0 p-2">
  //             <div className="md:p-6 lg:p-6 p-2 space-y-4 md:space-y-6">
  //               <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl ">
  //                 Sign-in to your account
  //               </h1>
  //               <form className="space-y-4 md:space-y-6" onSubmit={handleSignIn}>
  //                 <div>
  //                   <label
  //                     htmlFor="email"
  //                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
  //                   >
  //                     Your email
  //                   </label>
  //                   <input
  //                     type="email"
  //                     name="email"
  //                     id="email"
  //                     className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
  //                     placeholder="name@company.com"
  //                     value={formData.email}
  //                     onChange={handleInputChange}
  //                     required
  //                   />
  //                 </div>
  //                 <div>
  //                   <label
  //                     htmlFor="password"
  //                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
  //                   >
  //                     Password
  //                   </label>
  //                   <input
  //                     type="password"
  //                     name="password"
  //                     id="password"
  //                     placeholder="••••••••"
  //                     className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
  //                     value={formData.password}
  //                     onChange={handleInputChange}
  //                     required
  //                   />
  //                 </div>
  //                 <div className="flex items-center justify-between">
  //                   <div className="flex items-start">
  //                     <div className="flex items-center h-5">
  //                       <input
  //                         id="remember"
  //                         aria-describedby="remember"
  //                         type="checkbox"
  //                         className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300"
  //                       />
  //                     </div>
  //                     <div className="ml-3 text-sm">
  //                       <label htmlFor="remember" className="text-gray-500 ">
  //                         Remember me
  //                       </label>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 <ReCAPTCHAComponent onChange={handleRecaptcha} />
  //                 <button
  //                   type="submit"
  //                   className={`w-full text-black  hover:bg-primary-700
  //                                     focus:ring-4 focus:outline-none focus:ring-primary-300
  //                                     font-semibold rounded-lg text-md px-5 py-2.5 text-center ${isCaptchaValid ? "bg-yellow-400 " : "bg-yellow-300"}`}
  //                   disabled={!isCaptchaValid}
  //                 >
  //                   Sign in
  //                 </button>
  //               </form>
  //               <ToastContainer />
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     </div>
  //   );
  return (
    <div className="min-h-screen w-full relative">
      {/* Background */}
      <img
        src={backgroundImage}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover brightness-75"
      />

      {/* Overlay */}
      <div className="relative min-h-screen flex items-center justify-center px-4">
        {/* Card */}
        <div
          className="
        w-full 
        max-w-sm 
        bg-white/95 
        backdrop-blur-md
        rounded-2xl 
        shadow-2xl 
        p-6 
        sm:max-w-md 
        md:max-w-lg
        lg:p-8
      "
        >
          <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
            {isPOSLogin ? "POS Login" : "Sign-in to your account"}
          </h1>

          <form className="space-y-5" onSubmit={handleSignIn}>
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                placeholder="name@company.com"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="
                w-full 
                p-3 
                text-base 
                rounded-lg 
                border 
                border-gray-300 
                focus:ring-2 
                focus:ring-yellow-400 
                outline-none
              "
              />
            </div>

            {/* Password */}
            <div className="relative w-full">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Password
  </label>
  <input
    type={showPassword ? "text" : "password"}
    name="password"
    placeholder="••••••••"
    value={formData.password}
    onChange={handleInputChange}
    required
    className="
      w-full 
      p-3 
      pr-10  /* space for the icon */
      text-base 
      rounded-lg 
      border 
      border-gray-300 
      focus:ring-2 
      focus:ring-yellow-400 
      outline-none
    "
  />
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    className="absolute right-3 top-1/2 bottom-1/2 text-gray-500"
  >
    {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
  </button>
</div>

            {/* Remember */}
            <div className="flex items-center gap-2 text-sm">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember" className="text-gray-600">
                Remember me
              </label>
            </div>

            {/* Captcha */}
            <div className="flex justify-center">
              <ReCAPTCHAComponent onChange={handleRecaptcha} />
            </div>

            {/* Button */}
            <button
              type="submit"
              disabled={!isCaptchaValid}
              className={`
              w-full 
              py-3 
              rounded-lg 
              font-semibold 
              text-lg 
              transition 
              ${isCaptchaValid ? "bg-yellow-400 hover:bg-yellow-500" : "bg-yellow-300"}
            `}
            >
              Sign In
            </button>
          </form>

          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default Login;
